export default __webpack_public_path__ + "static/media/pro-elevate-dmb-banner-1.4787eed2.jpg";